import * as types from '../../../constants/ActionTypes';
import service from '../../../service';

export const getBestOffers = params => ({
    type: types.GET_BEST_OFFERS,
    payload: service.getQuickQuote(params),
});

export const setBestOffer = offer => ({
    type: types.SET_SELECTED_BEST_OFFER,
    offer,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/SelectBestOffer/selectBestOfferActions.js